'use client'
 
import { useEffect } from 'react'
 
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log comprehensive error details locally
    const errorDetails = {
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      name: error.name,
      timestamp: new Date().toISOString(),
      cause: error.cause,
      toString: error.toString(),
      // Try to get more details from the error object
      ...Object.getOwnPropertyNames(error).reduce((acc, prop) => {
        try {
          acc[prop] = (error as any)[prop];
        } catch {
          acc[prop] = 'Unable to access property';
        }
        return acc;
      }, {} as any)
    };

    console.error('Server Component Error Details:', errorDetails);

    // Route context
    const routeContext = {
      url: window.location.href,
      pathname: window.location.pathname,
      userAgent: navigator.userAgent,
      referrer: document.referrer
    };

    console.error('Route Context:', routeContext);

    // Send error to logging API for production debugging
    fetch('/api/log-error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        error: errorDetails,
        ...routeContext,
        context: 'Global Error Boundary'
      }),
    }).catch(logError => {
      console.error('Failed to send error to logging API:', logError);
    });
  }, [error])
 
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="rounded-lg bg-white p-8 shadow-lg max-w-md w-full">
        <h2 className="text-xl font-semibold text-red-600 mb-4">
          Application Error
        </h2>
        <p className="text-gray-600 mb-4">
          Something went wrong. Please try again.
        </p>
        <details className="mb-4">
          <summary className="cursor-pointer text-sm text-gray-500 hover:text-gray-700">
            Technical Details
          </summary>
          <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto max-h-32">
            {error.message}
            {error.digest && `\nDigest: ${error.digest}`}
          </pre>
        </details>
        <button
          onClick={reset}
          className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
        >
          Try again
        </button>
      </div>
    </div>
  )
}